const Search = () => {
  return (
    <div>
      <p> This is search</p>
    </div>
  );
};

export default Search;
